import React from 'react';
import PropTypes from 'prop-types';

import Cta from 'components/Core/Cta';
import IconSvg from 'components/Core/IconSvg';

import trackAction from 'utils/tracking';
import { buildMapsUrl } from 'utils/url';

import { ACTION_NODE_LINK, ACTION_TYPE_SECONDARY } from 'constants/Action';

const AccommodationCard = ({ url, name, promotionImage, streetName, postCode, houseNumber, city, distance }) => (
  <div className="flex flex-wrap -mx-4">
    <div className="flex-full max-w-full md:flex-none md:max-w-none px-4 relative">
      <img className="
      h-full 
      w-full 
      object-cover 
      object-top 
      rounded-lg
      min-w-330" 
      src={promotionImage.img.url} 
      alt={name} 
      />
      {distance && (
        <div className="absolute left-0 bottom-0 px-8 py-4 block lg:hidden">
          <div className="flex flex-col items-center justify-center rounded-lg bg-white text-secondary h-12 w-12">
            <div className="p-small font-bold">{distance}</div>
            <div className="p-small">km</div>
          </div>
        </div>
      )}
    </div>
    <div className="flex-1 max-w-full px-4 flex flex-col md:items-start">
      <h3 className="mt-6 mb-4 lg:mt-0">{name}</h3>
      {city && (
        <a
          href={buildMapsUrl(name, streetName, houseNumber, postCode, city)}
          target="_blank"
          rel="noreferrer"
          className="flex items-center underline md:no-underline"
          onClick={() => trackAction('accommodation-list', 'google maps', name)}
        >
          <IconSvg icon="location" className="mr-2 text-primary" size={35} />
          <div className="flex flex-wrap leading-6">
            <div className="flex-full max-w-full underline lg:flex-none lg:no-underline leading-4 mr-1">
              {streetName} {houseNumber},
            </div>
            <div className="flex-full max-w-full underline lg:flex-none lg:no-underline leading-4">
              {postCode} {city}
            </div>
          </div>
        </a>
      )}
      {url && (
        <Cta
          href={url}
          target="_blank"
          rel="noreferrer"
          className="mt-8 lg:mt-auto"
          node={ACTION_NODE_LINK}
          styleType={ACTION_TYPE_SECONDARY}
          showIcon={false}
          onClick={() => trackAction('accommodation-list', 'bezoek website', name)}
        >
          Bezoek website
        </Cta>
      )}
    </div>
    {distance && (
      /* eslint-disable max-len */
      <div className="hidden lg:block px-4">
        <div className="flex flex-col items-center justify-center rounded-lg bg-secondary-300 text-secondary h-24 w-24">
          <div className="h3">{distance}</div>
          <div className="p-intro">km</div>
        </div>
      </div>
      /* eslint-enable */
    )}
  </div>
);

AccommodationCard.defaultProps = {
  url: null,
  promotionImage: {
    img: {
      url: '/assets/330x220.jpg',
    },
  },
  streetName: '',
  postCode: '',
  houseNumber: '',
  city: '',
  distance: null,
};

AccommodationCard.propTypes = {
  url: PropTypes.string,
  name: PropTypes.string.isRequired,
  promotionImage: PropTypes.shape({
    img: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
  streetName: PropTypes.string,
  postCode: PropTypes.string,
  houseNumber: PropTypes.string,
  city: PropTypes.string,
  distance: PropTypes.string,
};

export default AccommodationCard;
